import React from "react";

const Notification = () => {
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 19.5V17.5H6V10.5C6 9.11667 6.41667 7.8875 7.25 6.8125C8.08333 5.7375 9.16667 5.03333 10.5 4.7V4C10.5 3.58333 10.6458 3.22917 10.9375 2.9375C11.2292 2.64583 11.5833 2.5 12 2.5C12.4167 2.5 12.7708 2.64583 13.0625 2.9375C13.3542 3.22917 13.5 3.58333 13.5 4V4.7C14.8333 5.03333 15.9167 5.7375 16.75 6.8125C17.5833 7.8875 18 9.11667 18 10.5V17.5H20V19.5H4ZM12 22.5C11.45 22.5 10.9792 22.3042 10.5875 21.9125C10.1958 21.5208 10 21.05 10 20.5H14C14 21.05 13.8042 21.5208 13.4125 21.9125C13.0208 22.3042 12.55 22.5 12 22.5ZM8 17.5H16V10.5C16 9.4 15.6083 8.45833 14.825 7.675C14.0417 6.89167 13.1 6.5 12 6.5C10.9 6.5 9.95833 6.89167 9.175 7.675C8.39167 8.45833 8 9.4 8 10.5V17.5Z"
        fill="#E3E3E3"
      />
    </svg>
  );
};

export default Notification;
